"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventObject = void 0;
const utils_common_transform_object_2_ga_format_1 = __importDefault(require("@gcloud-npm/utils.common.transform-object-2-ga-format"));
const utils_common_is_front_app_1 = __importDefault(require("@gcloud-npm/utils.common.is-front-app"));
/* LEGACY BLOCK BEGINS */
/**
 * NOrmaliza un string, generalmente para el envio de metrics
 * @param {string} str a transformar.
 * @returns {string} myExample --> my-example
 */
const toKebabCase = (entry = '') => {
    let kebapName = entry
        .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2')
        .toLowerCase();
    if (kebapName[0] === '-') {
        kebapName = kebapName.substr(1);
    }
    return kebapName;
};
const normalizeString = (str) => {
    let newStr = str;
    newStr = newStr.toLowerCase();
    newStr = newStr.replace(/á/g, 'a');
    newStr = newStr.replace(/é/g, 'e');
    newStr = newStr.replace(/í/g, 'i');
    newStr = newStr.replace(/ó/g, 'o');
    newStr = newStr.replace(/ú/g, 'u');
    newStr = newStr.replace(/ /g, '-');
    newStr = newStr.replace(/ñ/g, 'n');
    return newStr;
};
const createEventObject = (inputObj, eventType = 'click') => {
    const finalRes = {
        event: 'cms-component',
        'event-type': eventType,
        'component-name': '',
        'component-variation': '',
        'component-content': '',
        'component-product': '',
        'component-perso': {},
    };
    const keys = inputObj ? Object.keys(inputObj) : [];
    keys.forEach((key) => {
        const resKey = toKebabCase(key);
        let resValue = inputObj[key];
        if (typeof resValue === 'string') {
            resValue = normalizeString(resValue);
        }
        finalRes[resKey] = resValue;
        finalRes[resKey] = finalRes[resKey] || '';
    });
    return finalRes;
};
exports.createEventObject = createEventObject;
/* LEGACY BLOCK ENDS*/
const normalizeGAValues = (object) => {
    let res = {};
    const keys = Object.keys(object);
    keys.forEach(currentKey => {
        let currentValue = object[currentKey];
        if (typeof currentValue === 'string') {
            currentValue = normalizeString(currentValue);
        }
        res[currentKey] = currentValue;
    });
    return res;
};
const sendGaComponentEvent = (object2Send, options = { eventType: 'cms_component' }, test = false) => {
    let resSended = {};
    if (test || `${process.env.NEXT_PUBLIC_GTM_USAGE}` === 'gtag') {
        const gaObject = (0, utils_common_transform_object_2_ga_format_1.default)(object2Send);
        resSended = gaObject;
        if ((0, utils_common_is_front_app_1.default)() && window && window.gtag) {
            window.gtag('event', options.eventType, normalizeGAValues(gaObject));
        }
    }
    /* LEGACY BEHAVIOUR */
    if (Object.keys(resSended).length === 0 && (0, utils_common_is_front_app_1.default)()) {
        const object = (0, exports.createEventObject)(object2Send);
        resSended = object;
        if (window && window.nookInfoExchange) {
            window.nookInfoExchange.sendMessage('Metrics', object);
        }
        else {
            window.dataLayerGTM.push(object);
        }
    }
    return resSended;
};
exports.default = sendGaComponentEvent;
//# sourceMappingURL=index.js.map